
import { API } from '@/services/api.service'

export default {
  name: 'ButtonsLogin',
  props: ['google', 'facebook'],
  methods: {
    authenticate (provider) {
      window.location = `${this.$config.apiURL}/auth/${provider}`
    },
    async authenticateV2 (provider) {
      const { data } = await API.post(`/auth/${provider}`)
      const { url } = data
      window.open(url)
      window.addEventListener('message', this.messageListener, false)
    },
    messageListener (event) {
        if (event.origin === this.$config.apiURL) {
          if (event.data.success) {
            window.location.reload()
            // TODO Login user
            return
          }
          if (!event.data.success) {
            // TODO Display error
            this.$router.replace({ name: this.$route.name, query: event.data })
            return
          }
        }
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageListener)
  }
}
